module.exports = __webpack_public_path__ + "static/media/IMG-1982.6173d689.jpg";